import type { SoundLevel } from '../sound';
import type { VerificationStatus } from '../useVerification';
import { SOUND_LABEL } from './TopRightInfo';
import { useEffect, useState } from 'react';

export function OptionsMenu({ nickname, isHost, seated, away, pendingCount, sound, verification, canShuffle, onToggleSound, onGameConfig, onRequests, onShuffleSeats, onTopUp, onAway, onLeave, onVerify, onClose }: {
  nickname: string | null; isHost: boolean; seated: boolean; away: boolean; pendingCount: number; sound: SoundLevel; verification: VerificationStatus;
  canShuffle: boolean;   // no hand on the table: the host may shuffle the seats
  onToggleSound: () => void; onGameConfig: () => void; onRequests: () => void; onShuffleSeats: () => void; onTopUp: () => void; onAway: () => void; onLeave: () => void; onVerify: () => void; onClose: () => void;
}) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  async function copyLink(): Promise<void> {
    try { await navigator.clipboard.writeText(window.location.href); setCopied(true); } catch { setCopied(false); }
  }
  const item = (label: string, onClick: () => void, disabledTitle?: string) => (
    <button key={label} type="button" role="menuitem" className="popover-item" disabled={disabledTitle !== undefined} title={disabledTitle} onClick={onClick}>{label}</button>
  );
  return (
    <>
      <div className="popover-scrim" onClick={onClose} />
      <div className="popover" role="menu" aria-label="Options">
        <div className="popover-head">{nickname ?? 'Spectator'}</div>
        {isHost && item('Game Configurations', onGameConfig)}
        {isHost && item(`Requests (${pendingCount})`, onRequests)}
        {isHost && item('Shuffle seats', onShuffleSeats, canShuffle ? undefined : 'Between hands only')}
        {item(`Sound: ${SOUND_LABEL[sound]}`, onToggleSound)}
        {item(copied ? 'Copied invite link' : 'Copy invite link', () => void copyLink())}
        {verification !== 'idle' && item({ pending: 'Verify the deal', verified: 'Deal verified ✓', mismatch: 'Deal MISMATCH ✗' }[verification], onVerify)}
        {seated && item('Top up', onTopUp)}
        {seated && item(away ? "I'm back" : 'Away', onAway)}
        {seated && item('Leave seat', onLeave)}
      </div>
    </>
  );
}
